import i18next, { i18n } from "i18next";
import { LanguageCode } from "@al/base-lib";

import { I18nJson } from "../model/pageInfo";

type I18nResourceData = {
  [key in LanguageCode]: {
    translation: Record<string, string>;
  };
};

/**
 * 转换i18n数据格式
 */
export function transformI18nData(i18nJson: I18nJson): I18nResourceData {
  // 数据转换
  const i18nData = i18nJson
    ? Object.keys(i18nJson).reduce(
        (res, key) => {
          if (i18nJson[key]) {
            const languageKeys = Object.keys(i18nJson[key]) as LanguageCode[];
            for (let index = 0; index < languageKeys.length; index++) {
              if (res[languageKeys[index]]) {
                res[languageKeys[index]].translation[key] = i18nJson[key][languageKeys[index]];
              }
            }
          }
          return res;
        },
        {
          en: {
            translation: {},
          },
          in: {
            translation: {},
          },
          ms: {
            translation: {},
          },
          vi: {
            translation: {},
          },
          zh: {
            translation: {},
          },
        } as I18nResourceData
      )
    : ({} as I18nResourceData);
  return i18nData;
}

/**
 * 获取自定义i18n事例
 * @param i18nJson I18nJson
 * @param currentLang LanguageCode
 * @returns i18n
 */
export function getCustomI18nInstance(i18nJson: I18nJson, currentLang: LanguageCode): i18n {
  // 数据转换
  const i18nData = transformI18nData(i18nJson);

  const i18nInstance = i18next.createInstance();

  i18nInstance.init({
    fallbackLng: [currentLang],
    debug: false,
    resources: i18nData,
    lng: currentLang,
    interpolation: {
      escapeValue: false,
    },
  });

  return i18nInstance;
}
